import React from 'react';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';

export default function UpdateCustomerInfoDialog(props) {
    const open = props.open;
    const confirm = props.confirm;
    const cancel = props.cancel;
    const updateInfo = props.updateInfo;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();

    if (!updateInfo.invoiceAddrUpdateNeeded && !updateInfo.eInvAddrUpdateNeeded && !updateInfo.emailInvAddrUpdateNeeded)
        return null;

    if (open)
        return (
            <Dialog
                onClose={cancel}
                aria-labelledby="simple-dialog-title"
                open={open}
                fullWidth={true}
                maxWidth={'md'}
                fullScreen={fullScreen}>
                <DialogContent dividers>
                    <Grid container>
                        <Grid item xs={12}>
                            <h4>{t('invoice.updateFollowingToCustomerData')}</h4>
                        </Grid>
                        {updateInfo.invoiceAddrUpdateNeeded && (
                            <Grid item container sx={{ mt: '1em' }}>
                                <Grid item xs={12}>
                                    <h5>{t('general.invoicingAddress')}</h5>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    {updateInfo.newInvoiceAddrDest === 'customer' && (
                                        <div>
                                            {t('general.customer')}: {updateInfo.customer.name}
                                            <div style={{ textDecoration: 'line-through' }}>
                                                "{updateInfo.customer.billingAddress.streetAddress},&nbsp;
                                                {updateInfo.customer.billingAddress.zipCode}{' '}
                                                {updateInfo.customer.billingAddress.city}"
                                            </div>
                                        </div>
                                    )}
                                    {updateInfo.newInvoiceAddrDest === 'billingcustomer' && (
                                        <div>
                                            {t('general.customer')}: {updateInfo.billingCustomer.name}
                                            <div style={{ textDecoration: 'line-through' }}>
                                                "{updateInfo.billingCustomer.billingAddress.streetAddress},&nbsp;
                                                {updateInfo.billingCustomer.billingAddress.zipCode}{' '}
                                                {updateInfo.billingCustomer.billingAddress.city}"
                                            </div>
                                        </div>
                                    )}
                                    {updateInfo.newInvoiceAddrDest === 'location' && (
                                        <div>
                                            {t('general.location')}: {updateInfo.location.name}
                                            <div style={{ textDecoration: 'line-through' }}>
                                                "{updateInfo.location.billingAddress.streetAddress},&nbsp;
                                                {updateInfo.location.billingAddress.zipCode}{' '}
                                                {updateInfo.location.billingAddress.city}"
                                            </div>
                                        </div>
                                    )}
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <ArrowForwardIcon />
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    "{updateInfo.invoice.billingAddress.streetAddress},&nbsp;
                                    {updateInfo.invoice.billingAddress.zipCode} {updateInfo.invoice.billingAddress.city}
                                    "
                                </Grid>
                            </Grid>
                        )}
                        {updateInfo.eInvAddrUpdateNeeded && (
                            <Grid item container sx={{ mt: '1em' }}>
                                <Grid item xs={12}>
                                    <h5>{t('general.eInvoiceAddress')}</h5>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    {updateInfo.newEInvAddrDest === 'customer' && (
                                        <div>
                                            {t('general.customer')}: {updateInfo.customer.name}
                                            <div style={{ textDecoration: 'line-through' }}>
                                                "{updateInfo.customer.electronicInvoiceAddress.ovt},&nbsp;
                                                {updateInfo.customer.electronicInvoiceAddress.operatorBrokerId}
                                                ,&nbsp;
                                                {updateInfo.customer.electronicInvoiceAddress.operator}"
                                            </div>
                                        </div>
                                    )}
                                    {updateInfo.newEInvAddrDest === 'billingcustomer' && (
                                        <div>
                                            {t('general.customer')}: {updateInfo.billingCustomer.name}
                                            <div style={{ textDecoration: 'line-through' }}>
                                                "{updateInfo.billingCustomer.electronicInvoiceAddress.ovt},&nbsp;
                                                {updateInfo.billingCustomer.electronicInvoiceAddress.operatorBrokerId}
                                                ,&nbsp;
                                                {updateInfo.billingCustomer.electronicInvoiceAddress.operator}"
                                            </div>
                                        </div>
                                    )}
                                    {updateInfo.newEInvAddrDest === 'location' && (
                                        <div>
                                            {t('general.location')}: {updateInfo.location.name}
                                            <div style={{ textDecoration: 'line-through' }}>
                                                {updateInfo.location.electronicInvoiceAddress ? (
                                                    <span>
                                                        "{updateInfo.location.electronicInvoiceAddress.ovt},&nbsp;
                                                        {updateInfo.location.electronicInvoiceAddress.operatorBrokerId}
                                                        ,&nbsp;
                                                        {updateInfo.location.electronicInvoiceAddress.operator}"
                                                    </span>
                                                ) : (
                                                    <span>-</span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <ArrowForwardIcon />
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    "{updateInfo.invoice.electronicInvoiceAddress.ovt},&nbsp;
                                    {updateInfo.invoice.electronicInvoiceAddress.operatorBrokerId},&nbsp;
                                    {updateInfo.invoice.electronicInvoiceAddress.operator}"
                                </Grid>
                            </Grid>
                        )}
                        {updateInfo.emailInvAddrUpdateNeeded && (
                            <Grid item container sx={{ mt: '1em' }}>
                                <Grid item xs={12}>
                                    <h5>{t('invoice.emailInvoiceAddress')}</h5>
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    {updateInfo.newEmailInvAddrDest === 'customer' && (
                                        <div>
                                            {t('general.customer')}: {updateInfo.customer.name}
                                            <div style={{ textDecoration: 'line-through' }}>
                                                "{updateInfo.customer.emailInvoiceAddress}"
                                            </div>
                                        </div>
                                    )}
                                    {updateInfo.newEmailInvAddrDest === 'billingcustomer' && (
                                        <div>
                                            {t('general.customer')}: {updateInfo.billingCustomer.name}
                                            <div style={{ textDecoration: 'line-through' }}>
                                                "{updateInfo.billingCustomer.emailInvoiceAddress}"
                                            </div>
                                        </div>
                                    )}
                                    {updateInfo.newEmailInvAddrDest === 'location' && (
                                        <div>
                                            {t('general.location')}: {updateInfo.location.name}
                                            <div style={{ textDecoration: 'line-through' }}>
                                                {updateInfo.location.emailInvoiceAddress != null ? (
                                                    <span>"{updateInfo.location.emailInvoiceAddress}"</span>
                                                ) : (
                                                    <span>-</span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <ArrowForwardIcon />
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    "{updateInfo.invoice.emailInvoiceAddress}"
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        name="btn-modal-confirm"
                        onClick={confirm}
                        startIcon={props.busy ? <CircularProgress color={'secondary'} size={'1rem'} /> : null}
                        disabled={props.busy}>
                        {t('buttons.update')}
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                        variant="contained"
                        sx={{ bgcolor: 'grey.300', color: 'text.primary', '&:hover': { bgcolor: 'grey.400' } }}
                        name="btn-modal-cancel"
                        onClick={cancel}
                        disabled={props.busy}>
                        {t('buttons.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    return null;
}

UpdateCustomerInfoDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    confirm: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired,
    updateInfo: PropTypes.object.isRequired,
    busy: PropTypes.bool.isRequired,
};
